//tslint:disable
export const extractIconDomProps = (props: any) => {
   //https://reactjs.org/warnings/unknown-prop.html
   //list of problem props below - other solution is to specify all 100s of allowed dom props and return those
   const {
      icon,
      iconSet,
      ...domProps
   } = props;
   return domProps;
};
